module.exports = __webpack_public_path__ + "static/media/12.e08d9fa2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/12.jpg
// module id = 575
// module chunks = 0